import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../ts/ServerApi/types/actionParams';

export interface IPerformExtractEncryptionActionOnWorkbooksParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnWorkbooksRequest extends Request<IPerformExtractEncryptionActionOnWorkbooksParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnWorkbooks', {
      ids: ids,
      type: type
    });
  }
}
